import React, { useState } from 'react';
import { partial } from '../../../util/translation/translation';
import useConfig from '../../../util/useConfig';
import exampleCurrency from '../../user_tiers/components/exampleCurrency';

const START = 2350;
const MIN_RAISE = 50;

// A match shirt on the club's blue, made here so no image file is needed
const SHIRT_IMAGE = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(
  '<svg xmlns="http://www.w3.org/2000/svg" width="640" height="400" viewBox="0 0 640 400"><defs><linearGradient id="g" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#1b6fb8"/><stop offset="1" stop-color="#0b2e48"/></linearGradient></defs><rect width="640" height="400" fill="url(#g)"/><path d="M250 80l-90 45 30 70 40-18v163h180V177l40 18 30-70-90-45c-10 25-40 40-70 40s-60-15-70-40z" fill="#ffffff" opacity="0.92"/><text x="320" y="270" text-anchor="middle" font-family="Helvetica, Arial, sans-serif" font-size="72" font-weight="700" fill="#145583">10</text></svg>'
)}`;

/**
 * An auction item in the app, clickable: the item, the highest bid and the
 * time left; a bid raises it by the minimum (or more) and puts you in the
 * lead. Example values.
 */
const AuctionItemPreview = () => {
  const s = partial('shared');
  const currency = exampleCurrency(useConfig());
  const money = (amount) => `${amount.toLocaleString('sv-SE')} ${currency}`;
  const [highest, setHighest] = useState(START);
  const [bids, setBids] = useState(23);
  const [leading, setLeading] = useState(false);

  const bid = (raise) => {
    setHighest((value) => value + raise);
    setBids((count) => count + 1);
    setLeading(true);
  };

  return (
    <div className="tier-phone auction-preview">
      <div className="heart-preview__head">
        <span aria-hidden>‹</span>
        {s('auctionPreviewHouse')}
      </div>
      <div className="auction-preview__body">
        <img className="auction-preview__image" src={SHIRT_IMAGE} alt="" />
        <div className="auction-preview__info">
          <strong>{s('auctionPreviewItem')}</strong>
          <span className="auction-preview__time">
            {s('auctionPreviewCloses', { time: '02:14:33' })}
          </span>
        </div>
        <div className="auction-preview__bid">
          <span>
            <span>{s('auctionPreviewHighest')}</span>
            <b>{money(highest)}</b>
          </span>
          <span className="auction-preview__count">
            {leading ? (
              <span className="auction-preview__lead">
                {s('auctionPreviewLeading')}
              </span>
            ) : (
              s('auctionPreviewBids', { count: bids })
            )}
          </span>
        </div>
        <div className="auction-preview__actions">
          <button type="button" onClick={() => bid(MIN_RAISE)}>
            {s('auctionPreviewBidButton', {
              amount: money(highest + MIN_RAISE),
            })}
          </button>
          <button
            type="button"
            className="auction-preview__more"
            onClick={() => bid(MIN_RAISE * 4)}
          >
            +{money(MIN_RAISE * 4)}
          </button>
        </div>
        <span className="auction-preview__note">
          {s('auctionPreviewExtension', { minutes: 2 })}
        </span>
      </div>
    </div>
  );
};

export default AuctionItemPreview;
